import React from "react";
import { Link } from "react-router-dom";
import PageTopSlider from "../components/PageTopSlider";
import ReviewsSlider from "../components/ReviewsSlider";
import ContactForm from "../components/ContactForm";
import SEO from "../components/SEO";

export default function About() {
  return (
    <div className="bg-[#FAF9F6] text-stone-800">
      <SEO
        title="Om os | ET Danmark ApS"
        description="Hos ET Danmark ApS har vi 20 års erfaring i byggebranchen. Vi leverer uvildig, grundig og pålidelig energirådgivning, energimærkning og trykprøvning i hele Jylland og Fyn."
        canonical="https://etdanmark.com/om-os"
        ogImage="https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07577.jpg"
      />
      {/* 1. TOP SLIDER HERO */}
      <PageTopSlider
        title="Om os"
        subtitle="Med mere end 20 års erfaring i byggebranchen leverer vi uvildig, grundig og pålidelig energirådgivning til både private boligejere og erhverv i hele Jylland og Fyn."
        badge="20 års erfaring i byggebranchen"
        breadcrumbs={[
          { label: "Forside", to: "/" },
          { label: "Om os" },
        ]}
        actions={
          <>
            <a
              href="tel:+4542499595"
              className="px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold text-sm shadow-md transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true"></i>
              <span>Ring: 42 49 95 95</span>
            </a>
            <Link
              to="/prisberegner"
              className="px-6 py-3 rounded-full bg-white/15 hover:bg-white/25 border border-white/30 text-white font-bold text-sm backdrop-blur-xs transition-all flex items-center gap-2"
            >
              <i className="fa-solid fa-calculator text-emerald-300 text-xs" aria-hidden="true"></i>
              <span>Beregn din pris</span>
            </Link>
          </>
        }
        image={{
          url: "https://assets.auxodev.dk/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07506.jpg",
          alt: "ET Danmark Lars energikonsulent",
        }}
      />

      {/* Lars profil og introduktion */}
      <section className="py-14 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-7 space-y-5">
              <h2 className="text-2xl sm:text-3xl font-bold text-stone-900 tracking-tight">
                Mød Lars fra ET Danmark ApS
              </h2>

              <blockquote className="p-6 rounded-2xl bg-stone-50 border border-stone-200 text-stone-800 text-base sm:text-lg leading-relaxed shadow-2xs italic">
                "Mit navn er Lars, og jeg har <strong className="font-bold not-italic text-stone-900">20 års erfaring i byggebranchen, med et bredt kendskab til hele byggeriet</strong>, gennem mange års selvstændig virke med totalentrepriser. Min passion er at give mine kunder, både store og små, en god oplevelse og kvalitet for pengene. Jeg bestræber mig på at yde den bedste service i branchen, og værner om de faste samarbejdspartnere."
              </blockquote>

              <div className="pt-2 flex flex-wrap gap-4">
                <a
                  href="tel:+4542499595"
                  className="px-6 py-3.5 rounded-full bg-[#165B4C] hover:bg-[#11463A] text-white font-bold text-sm shadow transition-all flex items-center gap-2 whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring til Lars: 42 49 95 95</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3.5 rounded-full bg-white hover:bg-stone-50 border border-stone-300 text-stone-800 font-bold text-sm shadow-2xs transition-all flex items-center gap-2"
                >
                  <i className="fa-solid fa-envelope text-emerald-700" aria-hidden="true"></i>
                  <span>Send en besked</span>
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5 flex items-center">
              <div className="w-full rounded-3xl overflow-hidden shadow-xl border-4 border-stone-100 bg-stone-100 aspect-4/3">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=900,quality=85,format=auto/assets/769d49b2-5afc-461a-944c-d9cca711718f/dsc07445.jpg"
                  alt="ET Danmark arbejdsbord og rådgivning"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Værdier og Faglighed */}
      <section className="py-16 bg-white border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mb-12">
            <h2 className="text-3xl font-extrabold text-stone-900 tracking-tight">
              Uvildig rådgivning med solid håndværksmæssig baggrund
            </h2>
            <p className="text-stone-600 text-sm sm:text-base mt-3 leading-relaxed">
              Hos ET Danmark ApS møder du en rådgiver, der forstår virkeligheden ude på byggepladsen og i boligen. Med en baggrund i totalentrepriser ser vi ikke kun på teoretiske tal, men på boligens helhed og praktiske udførelse.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="p-6 rounded-2xl bg-[#FAF9F6] border border-stone-200">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center text-lg mb-4">
                <i className="fa-solid fa-scale-balanced" aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-stone-900 text-base mb-2">100% Uvildig</h3>
              <p className="text-xs sm:text-sm text-stone-600 leading-relaxed">
                Vi har ingen økonomiske interesser i at sælge dig bestemte produkter eller materialer. Vores råd er altid i din og din boligs bedste interesse.
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-[#FAF9F6] border border-stone-200">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center text-lg mb-4">
                <i className="fa-solid fa-handshake" aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-stone-900 text-base mb-2">Tæt samarbejde</h3>
              <p className="text-xs sm:text-sm text-stone-600 leading-relaxed">
                Vi værner om langvarige relationer med både private boligejere, entreprenører, arkitekter og boligforeninger i hele Danmark.
              </p>
            </div>

            <div className="p-6 rounded-2xl bg-[#FAF9F6] border border-stone-200">
              <div className="w-10 h-10 rounded-xl bg-emerald-100 text-emerald-800 flex items-center justify-center text-lg mb-4">
                <i className="fa-solid fa-stopwatch" aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-stone-900 text-base mb-2">Hurtig levering</h3>
              <p className="text-xs sm:text-sm text-stone-600 leading-relaxed">
                Tid er afgørende ved hushandler og byggeansøgninger. Vi leverer gennemarbejdede rapporter og dokumentation til tiden.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Virksomhedsdata */}
      <section className="py-14 bg-stone-50 border-b border-stone-200/70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
            <div className="bg-white p-6 rounded-2xl border border-stone-200">
              <p className="text-3xl font-extrabold text-[#165B4C]">20+ år</p>
              <p className="text-xs text-stone-500 font-medium mt-1">I byggebranchen</p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-stone-200">
              <p className="text-3xl font-extrabold text-[#165B4C]">100%</p>
              <p className="text-xs text-stone-500 font-medium mt-1">Uvildig rådgivning</p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-stone-200">
              <p className="text-3xl font-extrabold text-[#165B4C]">Jylland og Fyn</p>
              <p className="text-xs text-stone-500 font-medium mt-1">Lokal service & kørsel</p>
            </div>
            <div className="bg-white p-6 rounded-2xl border border-stone-200">
              <p className="text-3xl font-extrabold text-[#165B4C]">24 timer</p>
              <p className="text-xs text-stone-500 font-medium mt-1">Hurtigt mailsvar</p>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Slider */}
      <ReviewsSlider />

      {/* Kontakt Sektion */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-2xl mx-auto mb-8 text-center">
            <h2 className="text-3xl font-bold text-stone-900">Kontakt os</h2>
            <p className="text-stone-600 text-sm mt-1">
              Du kan let og hurtigt sende os en besked i nedenstående formular.
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <ContactForm
              title="Send os en besked"
              subtitle="Vi vender tilbage hurtigst muligt."
            />
          </div>
        </div>
      </section>
    </div>
  );
}
